import { Box, Text } from '@chakra-ui/react';

import { useAppSelector } from '@/store/hooks';

const Header = () => {
  const { user } = useAppSelector((state) => state.auth);

  return (
    <Box
      px={8}
      py={3}
      backgroundColor="#FFF"
      width="100%"
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      gap={4}
      id="app-header"
    >
      <Box display="flex" alignItems="center" gap={3}>
        <Box>
          <Text fontSize={16} fontWeight={500} color="#000">
            {user?.fullName}
          </Text>
          <Text fontSize={16} fontWeight={400} color="#000">
            {user?.email}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default Header;